import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'

/**
 * SearchResultsNotFoundModal Component
 * 
 * Error message modal displayed when search query returns no results. Provides helpful suggestions
 * to user including checking for spelling errors, trying different search terms, and contacting
 * support if unable to find desired records. Typically rendered in alert containers during
 * search operations with no matching records.
 * 
 * @returns {JSX.Element} Error message with icon and search troubleshooting suggestions
 */
const SearchResultsNotFoundModal = () => {
  return (
    <div style={{ paddingTop: "10px" }}>
      <p style={{ color: "red" }}>
        <AiOutlineCloseCircle className="alert-icon" /> Error
      </p>
      <p style={{ marginLeft: "28px" }}>
        Sorry, your search query returned no results.
      </p>
      <ul style={{ marginLeft: "3px" }}>
        <li>Check for typing or spelling errors</li>
        <li>Use a different search term and try a new search</li>
        <li>We may not yet have the item you're searching for</li>
      </ul>
      <p style={{ marginLeft: "28px" }}>
        If you still can't find what you're looking for,{" "}
        <a
          href="https://www.roiquant.com/contact"
          target="_blank"
          rel="noopener noreferrer"
        >
          share your feedback
        </a>{" "}
        to help us improve.
      </p>
    </div>
  )
}

export default SearchResultsNotFoundModal